<template>
  <div class="account-warpper">
    <div class="bg-white ">
      <div class="margin-bottom-sm flex align-center justify-between">
        <div class="flex align-center">
          <div class="flex align-center margin-right-sm">
            <span>队伍名称：</span>
            <el-input v-model="name" placeholder="请输入队伍名称" class="flex-sub"></el-input>
          </div>
<!--          <div class="flex align-center margin-right-sm">-->
<!--            <span>手机号：</span>-->
<!--            <el-input v-model="phone" placeholder="请输入手机号" class="flex-sub"></el-input>-->
<!--          </div>-->
          <!--          <div class="flex align-center margin-right-sm">-->
          <!--            <span>角色：</span>-->
          <!--            <el-select v-model="power" placeholder="请选择角色" class="flex-sub">-->
          <!--              <el-option-->
          <!--                v-for="item in powerList"-->
          <!--                :key="item.value"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value">-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </div>-->
          <el-button type="primary" @click="hanldSearch">搜索</el-button>
        </div>
        <!--        <el-button type="primary" @click="accountDialog = true">新增志愿者</el-button>-->
        <el-button
          type="primary"
          @click="addTemaList(0)"
        >添加服务队
        </el-button>
      </div>
      <el-table
        :data="accountList"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="双暖服务队" prop="name"></el-table-column>
        <el-table-column label="所属小区" prop="xiaoqu_names"></el-table-column>
        <el-table-column label="志愿者队长" prop="duizhang_name"></el-table-column>
        <el-table-column label="队员人数" prop="member_num"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                size="small"
                type="primary"
                @click="addTemaList(scope.row.id)"
              >编辑
              </el-button>
              <el-button
                size="small"
                type="primary"
                @click="delTemaList(scope.row.id)"
              >删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="accountList.length > 0"
        class="page-all"
        background
        @current-change="getAdminList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {powerTypes} from "@/utils/utils";
import { getServiceTeamList,delServiceTeam} from "@/api/weilao";
export default {
  name: "account",
  data() {
    return {
      name: '',
      phone: '',
      page: 1,
      limit: 10,
      total: 0,
      accountList: [],
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "双暖为老 / 双暖服务队", false);
    this.getAdminList()
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  components: {
  },
  methods: {
    //  删除
    delTemaList(id){
      this.$confirm('您确定要删除该服务队吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await delServiceTeam(id);
      if (this.accountList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getAdminList();
      this.$message.success(_state.info);
    },
    //  志愿者详情
    addTemaList(id){
      this.$router.push('/home/team-list-edit/' + id)
    },
    //  搜索
    hanldSearch(){
      this.page = 1
      this.getAdminList()
    },
    //  获取列表
    async getAdminList() {
      let _list = await getServiceTeamList(
        this.name,
        this.page,
        this.limit,
      )
      this.accountList = _list.data?_list.data:[]
      this.total = _list.total_number
    }
  },
  filters: {
    power(val){
      return powerTypes(val)
    }
  },
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
